import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";

import { Modal, Loader } from "semantic-ui-react";
import { MdClose, MdOpenInNew } from "react-icons/md";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

import {
  Container,
  Forms,
  ButtonContainer,
  Header,
  ManagersContainer,
  CheckInput,
  Reports,
  InputDateTime,
  LinkButton,
} from "./styles";
import swal from "sweetalert";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import CollaboratorsManagementModal from "../components/Modals/CollaboratorsManagementModal";
import ActionButton from "../components/ActionButton";
import DateSelector from "../components/DateSelector";
import Input from "../components/Input";
import { Toggle } from "../components/Toggle";
import { InputUrl } from "../components/InputUrl";
import { UpdateLogo } from "../components/uploadLogo";
import Back from "../components/Back";
import { FaPlus } from "react-icons/fa";
import InputSelector from "../components/InputSelector";
import ModelListarAluno from "../components/Modals/ListarAluno";
import { getNodeToken } from "../../../../services/auth_node";
import ModelAddAluno from "../components/Modals/AddAluno";
import ConfirmDelete from "../components/Modals/ConfirmDelete";
import {
  smallDateFormat,
  smallDateFormatWithTime,
  smallDateFormatWithTimeResetUTC,
} from "../../../../utils/Utils";

export const NovoEditarEmpresas = (props) => {
  const [companyName, setCompanyName] = useState(""); // Nome atual da empresa no banco
  const [name, setName] = useState(""); // Nome da empresa q vai ser atualizado
  const [collaboratorsTotal, setCollaboratorsTotal] = useState(0); // total de colaboradores que a empresa pode ter
  const [managers, setManagers] = useState([]); // lista de colaboradores que são gerentes
  const [accessTime, setAccessTime] = useState("");
  const [collaborators, setCollaborators] = useState([]); // lista de colaboradores (colaborador padrão e líder)

  const [collabOptions, setCollabOptions] = useState([]); // lista de colaboradores para o input selector
  const [trailsOptions, setTrailsOptions] = useState([]); // lista de trilhas para o input selector
  const [teamsOptions, setTeamsOptions] = useState([]); // lista de times para o input selector
  // const [collabCoursesOptions, setCollabCoursesOptions] = useState([]); // lista de cursos de um colaborador para o input selector
  // const [certificateUrl, setCertificateUrl] = useState(undefined);

  const [companyIsActive, setCompanyIsActive] = useState(false); // status da empresa ativa ou não
  const [licenseUse, setLicenseUse] = useState(0); // total de licenças usadas
  const [logoUrl, setLogoUrl] = useState(""); // logo da empresa
  const [hasFreeTrial, setHasFreeTrial] = useState(false); // se a empresa tem cadastro de free trial
  const [diasFreeTrial, setDiasFreeTrial] = useState(0); // dias de free trial
  const [activeFreeTrial, setActiveFreeTrial] = useState(false); // se o free trial ta ativo
  const [dataInicioFreeTrial, setDataInicioFreeTrial] = useState(""); // data de inicio do free trial
  const [url, setUrl] = useState(""); // url da empresa

  const [loading, setLoading] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [loadingCertificate, setLoadingCertificate] = useState(false);

  const [managerEmailAdded, setManagerEmailAdded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [collabListModal, setCollabListModal] = useState(false);
  const [colorPrimary, setColorPrimary] = useState("");
  const [colorSecondary, setColorSecondary] = useState("");
  const [imageLogin, setImageLogin] = useState("");

  const [erros, setErros] = useState({});

  // STATES TO INPUT SELECTOR
  const [reportType, setReportType] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedCollaborator, setSelectedCollaborator] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [logoChangeCount, setLogoChangeCount] = useState(0);

  const id = props.match.params.id;

  useEffect(() => {
    const getCompany = async () => {
      await api
        .get(`/incompany-read/${id}`)
        .then((res) => {
          setName(res.data.name);
          setCompanyName(res.data.name);
          setCollaboratorsTotal(res.data.valid_employees);
          setCompanyIsActive(res.data.status === 2);
          setManagers(res.data.menagers || []);
          setLicenseUse(res.data.licenseUse);
          setCollaborators(res.data.collaborators);
          setLogoUrl(res.data.logo);
          setUrl(res.data.url);
          setAccessTime(res.data?.expires_in ? res.data.expires_in : null);
          setColorPrimary(res.data.color_primary);
          setColorSecondary(res.data.color_secondary);
          setImageLogin(res.data.url_image_login);

          if (
            res.data.trails.length > 0 ||
            res.data.collaborators.length > 0 ||
            res.data.teams.length > 0
          ) {
            const trailOptions = res.data.trails.map((trail, index) => ({
              key: index,
              text: `[${trail.id}] ${trail.title}`,
              value: trail.id,
              icon: "delete",
            }));
            setTrailsOptions(trailOptions);

            const collabOptions = res.data.collaborators.map(
              (collab, index) => ({
                key: index,
                text: `[${collab.id_pessoa}] ${collab.email}`,
                value: collab.id_pessoa,
                icon: "delete",
              })
            );
            setCollabOptions(collabOptions);

            const teamOptions = res?.data.teams.map((team, index) => ({
              key: index,
              text: `[${team.id}] ${team.name}`,
              value: team.id,
              icon: "delete",
            }));
            setTeamsOptions(teamOptions);

            return;
          } else {
            setCollabOptions([]);
            setTrailsOptions([]);
            setTeamsOptions([]);
          }
        })
        .catch((err) => {
          swal(
            "Empresa não encontrada",
            `Empresa com id: ${id} não encontrada`,
            "error"
          );
          console.error(err);
        });
    };
    getCompany();
    // const getCollabCourses = async () => {
    //   api
    //     .get(`/incompany/v3/course-collaborator/${selectedCollaborator}`, {
    //       headers: {
    //         access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
    //       },
    //     })
    //     .then((res) => {
    //       if (res.data.length > 0) {
    //         const collabCourseOptions = res.data.map((course, index) => ({
    //           key: index,
    //           text: `[${course.id}] ${course.name}`,
    //           value: course.id,
    //         }));
    //         setCollabCoursesOptions(collabCourseOptions);
    //         return;
    //       }
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // };
    // if (selectedCollaborator) {
    //   getCollabCourses();
    // }
    // }, [id, selectedCollaborator]);
  }, [id]);

  useEffect(() => {
    api.get(`/incompany/free-trial/${id}`).then((response) => {
      if (response.data.createdAt) {
        setHasFreeTrial(true);
        setDiasFreeTrial(response.data.days);
        setActiveFreeTrial(!!response.data.is_active);
        setDataInicioFreeTrial(response.data.createdAt);
      }
    });
  }, []);

  const handleUpdateStatus = async () => {
    await api
      .put(`/admin/incompany/v3/${id}/change-status`, {
        status: !companyIsActive ? 2 : 1,
      })
      .then((res) => {
        setCompanyIsActive(!companyIsActive);
        //swal('Sucesso', 'Status da empresa atualizado com sucesso', 'success');
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const submitUpdate = async () => {
    if (loading) return;
    const currentErros = {};

    if (!accessTime) {
      swal(
        "POR FAVOR PREENCHA A VALIDADE",
        "É essencial que tenhamos uma validade pre-definida para que possamos ter controle do fluxo de clientes",
        "warning"
      );
      return;
    }
    const data = {
      name: name.trim(),
      collaboratorsTotal: +collaboratorsTotal,
      accessTime: new Date(accessTime),
      collaborators,
      managers,
      url: url?.trim(),
      logo: logoUrl?.trim(),
      theme: {
        color_primary: colorPrimary,
        color_secondary: colorSecondary,
        url_image_login: imageLogin,
      },
    };

    Object.entries(data).forEach(([key, value]) => {
      if (!value) {
        currentErros[key] = "Campo obrigatório";
      }
    });

    if (licenseUse > collaboratorsTotal) {
      currentErros.collaboratorsTotal =
        "A quantidade de convites não pode ser maior que o número de colaboradores";
    }

    if (Object.keys(currentErros).length > 0) {
      setErros(currentErros);
      return;
    }

    const logs = {
      local: `admin/lms/${id}`,
      texto: `o usuário administrador atualizou os dados: [${JSON.stringify(
        data
      )}] da empresa ${companyName} [id_company:${id}]`,
    };

    setLoading(true);

    await api
      .put(`/admin/incompany/v3/${id}`, data)
      .then(async () => {
        swal({
          title: "Sucesso",
          text: "Empresa atualizada com sucesso",
          icon: "success",
          button: "OK",
        }).then(() => {
          window.location.href = `/admin/lms/${id}`;
        });
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
      })
      .catch((err) => {
        if (err.response.status === 409) {
          const emails = err.response.data.data.join(", ");
          swal({
            title: "Erro",
            text: `Os seguintes e-mails já estão cadastrados: ${emails}`,
            icon: "error",
            button: "OK",
          });
          return;
        }

        swal({
          title: "Erro",
          text: "Erro ao criar empresa",
          icon: "error",
          button: "OK",
        });
      });

    if (hasFreeTrial) {
      await api
        .put(`/incompany/free-trial/${id}`, {
          days: diasFreeTrial,
          is_active: activeFreeTrial ? 1 : 0,
        })
        .catch((err) => console.log({ err }));
    }

    setLoading(false);
  };

  const handleEditManager = (id, value) => {
    const newManagers = managers.map((manager) => {
      if (manager.id === id) {
        manager.email = value;
        manager.isEdited = true;
      }
      return manager;
    });

    setManagers(newManagers);
  };

  const handleRemoveManager = (id) => {
    const newManagers = managers.filter((manager) => manager.id !== id);
    setManagers(newManagers);
  };

  function formatDate(inputDate) {
    const parts = inputDate.split("-");
    const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    return formattedDate;
  }

  // async function handleReport(typeName, typeBRName) {
  //   setLoadingReport(true);
  //   try {
  //     const report = await api.get("/incompany/v3/metrics/engagement/report", {
  //       headers: {
  //         access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
  //       },
  //       params: {
  //         id_company: id,
  //         type: typeName,
  //       },
  //     });
  //     const report_url = await api.post(
  //       "/incompany/reports/general-engagement",
  //       {
  //         data: report.data,
  //         id_company: id,
  //         type: typeBRName,
  //       }
  //     );

  //     const a = document.createElement("a");

  //     const url = report_url.data.url;

  //     if (!url) {
  //       toast.error(
  //         "Erro ao gerar relatório. Tente novamente em alguns minutos"
  //       );
  //       setLoadingReport(false);
  //       return;
  //     }

  //     a.href = url;
  //     a.download = `${url.split("/").pop()}`;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     setLoadingReport(false);

  //     const logs = {
  //       local: `admin/lms/${id}`,
  //       texto: `gerou o relatório sobre (${typeBRName}s) da empresa ${companyName} [id_company:${id}]`,
  //     };

  //     await api.post("system_logs", {
  //       acao: JSON.stringify(logs),
  //     });

  //     return;
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Erro ao gerar relatório. Tente novamente em alguns minutos");
  //     setLoadingReport(false);

  //     return;
  //   }
  // }

  // async function generateCertificate() {
  //   setLoadingCertificate(true);

  //   try {
  //     await api
  //       .post("admin/certificate", {
  //         userId: selectedCollaborator,
  //         courseId: selectedCourse,
  //       })
  //       .then(async (res) => {
  //         setCertificateUrl(res.data.url);
  //         swal({
  //           title: "Certificado gerado com sucesso",
  //           text: "Acesse-o no link gerado logo abaixo",
  //           icon: "success",
  //           button: "OK",
  //         });
  //         const logs = {
  //           local: `admin/lms/${id}`,
  //           texto: `Emitiu o certificado do curso (${selectedCourse}) para o colaborador (${selectedCollaborator}) da empresa ${companyName} [id_company:${id}]`,
  //         };
  //         await api.post("system_logs", {
  //           acao: JSON.stringify(logs),
  //         });
  //         setLoadingCertificate(false);
  //         // setSelectedCollaborator("");
  //         // setSelectedCourse("");
  //       });
  //     return;
  //   } catch (error) {
  //     console.error(error);
  //     toast.error(
  //       "Erro ao gerar certificado. Tente novamente em alguns minutos"
  //     );
  //     const logs = {
  //       local: `admin/lms/${id}`,
  //       texto: `Tentou emitir o certificado do curso (${selectedCourse}) para o colaborador (${selectedCollaborator}) da empresa ${companyName} [id_company:${id}] - Erro: ${error}`,
  //     };
  //     await api.post("system_logs", {
  //       acao: JSON.stringify(logs),
  //     });
  //     setLoadingCertificate(false);

  //     return;
  //   }
  // }

  // const handleReportType = (value) => {
  //   setReportType(value);
  // };

  // const handleCollaboratorChange = (value) => {
  //   setSelectedCollaborator(value);
  // };

  // const handleCourseChange = (value) => {
  //   setSelectedCourse(value);
  // };

  // const handleReportChange = (value) => {
  //   switch (value) {
  //     case "Colaborador":
  //       return handleReport("collaborator", "colaborador");

  //     case "Times":
  //       return handleReport("team", "time");

  //     case "Trilhas":
  //       return handleReport("trail", "trilha");

  //     default:
  //       break;
  //   }
  // };

  const handleChangeLogo = (url) => {
    setLogoUrl(url);
    setLogoChangeCount((prev) => prev + 1);

    toast.success("Logo atualizada com sucesso");
  };
  const handleChangeLogoLogin = (url) => {
    setImageLogin(url);
    toast.success("Logo atualizada com sucesso");
  };

  const reportTypeUtils = [
    {
      key: 0,
      text: "Colaborador",
      value: "Colaborador",
    },
    {
      key: 1,
      text: "Times",
      value: "Times",
    },
    {
      key: 2,
      text: "Trilhas",
      value: "Trilhas",
    },
  ];

  return (
    <div style={{ width: "100%", paddingLeft: "250px" }}>
      <AdminMenu />
      <Container>
        <Back actualPage={"Editar Empresa"} />

        <Header>
          <div>
            <h1>{companyName}</h1>
            <LinkButton href={`https://${url}.voitto.com.br`} target="_blank">
              Link da Empresa
            </LinkButton>
            <span>
              <Toggle checked={companyIsActive} onChange={handleUpdateStatus} />
              {companyIsActive ? "Ativo" : "Inativo"}
            </span>
          </div>
        </Header>

        <Forms>
          <div className="content">
            <Input
              label="Nome da Empresa"
              placeholder="Nome da Empresa"
              height={"height: 2.76rem;"}
              value={name}
              setValue={setName}
              onFocus={() => setErros((prev) => ({ ...prev, name: "" }))}
              error={erros.name}
            />
            <ManagersContainer>
              {managers?.length > 0 &&
                managers.map((manager) => (
                  <div className="manager__wrapper" key={manager.id}>
                    <label>E-mail do Administrador Master (RH)</label>
                    <span>
                      <input
                        value={manager.email}
                        placeholder="E-mail do gestor"
                        onChange={(e) =>
                          handleEditManager(manager.id, e.target.value)
                        }
                        onFocus={() =>
                          setErros((prev) => ({ ...prev, managerEmail: "" }))
                        }
                      />
                      <button
                        title="Remover gestor"
                        onClick={() => {
                          setConfirmModal(true), setSelectedManager(manager.id);
                        }}
                      >
                        <MdClose size={18} />
                      </button>
                    </span>
                  </div>
                ))}
            </ManagersContainer>
            <div className="collab__wrapper">
              <Input
                label="Total de colaboradores no painel"
                value={collaboratorsTotal}
                setValue={(e) => setCollaboratorsTotal(+e)}
                type="number"
                min={licenseUse || 0}
                error={erros.collaboratorsTotal}
                onFocus={() =>
                  setErros((prev) => ({ ...prev, collaboratorsTotal: "" }))
                }
              />
              <div className="buttons">
                <ActionButton
                  text="Ver colaboradores"
                  onClick={() => setCollabListModal(true)}
                />
                <ActionButton
                  text="Adicionar colaboradores"
                  onClick={() => setModalOpen(true)}
                  icon={<FaPlus />}
                />
              </div>
            </div>

            {/* <div>
              <InputSelector
                placeholder="Busque pelo nome da trilha"
                customLabel="Trilhas da Empresa"
                fluid
                search
                selection
                options={trailsOptions}
                // onChange={handleTreinamentoChange}
                // searchQuery={treinamentoSearch}
                // onSearchChange={handleTreinamentoSearchChange}
              />
            </div> */}
            {/*  */}
            {/* Deprecated
            <InputUrl
              value={url}
              setValue={setUrl}
              error={erros.url}
              onFocus={() => setErros(prev => ({ ...prev, url: "" }))}
            /> */}
            {/* 
            {hasFreeTrial && (
              <Input
                label="Dias Teste Grátis"
                value={diasFreeTrial}
                setValue={(e) => setDiasFreeTrial(+e)}
                type="number"
                min={licenseUse || 0}
              />
            )} */}
          </div>

          <div className="content">
            <UpdateLogo
              logoUrl={logoUrl ? `${logoUrl}?count=${logoChangeCount}` : ""} // Forma usada para evitar problemas com o cache do navegador
              setLogoUrl={handleChangeLogo}
              name={name}
              error={erros.logo}
              cleanError={() => setErros((prev) => ({ ...prev, logo: "" }))}
            />
            {/* <InputDateTime
              label="Prazo de Acesso"
              value={new Date(accessTime)}
              type="datetime-local"
              onChange={(e) => setAccessTime(e.target.value)}
            /> */}

            {/* <DateSelector
              label="Prazo de Acesso"
              value={accessTime}
              setValue={setAccessTime}
              error={erros.accessTime}
              onFocus={() => setErros((prev) => ({ ...prev, accessTime: "" }))}
            /> */}
            <label
              name="accessTime"
              htmlFor="accessTime"
              style={{
                padding: 0,
                margin: 0,
                fontSize: "1rem",
                fontWeight: "bold",
                minWidth: "300px",
              }}
            >
              Validade: <br />
              <input
                label="Prazo de Acesso"
                value={accessTime ? accessTime.split(" ")[0] : ""}
                onFocus={() =>
                  setErros((prev) => ({ ...prev, accessTime: "" }))
                }
                onChange={(e) => setAccessTime(e.target.value)}
                type="date"
                style={{
                  padding: ".5rem 1rem",
                  border: "1px solid #96989a",
                  borderRadius: "5px",
                }}
              />
            </label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: "10px",
              }}
            >
              <label>Cor Primária</label>
              <InputDateTime
                label="Cor Primária"
                type="color"
                id="primary"
                name="primary"
                value={colorPrimary}
                onChange={(e) => setColorPrimary(e.target.value)}
              />
              <label>Cor Secundária</label>
              <InputDateTime
                label="Cor Secondary"
                type="color"
                id="secondary"
                name="secondary"
                value={colorSecondary}
                onChange={(e) => setColorSecondary(e.target.value)}
              />
            </div>
            <small>
              * A cor primária é a cor principal do painel. Não defina cores
              extremamente escuras nem claras. Escolha a cor baseada na logo da
              empresa.
            </small>
            <UpdateLogo
              logoUrl={
                imageLogin ? `${imageLogin}?count=${logoChangeCount}` : ""
              }
              setLogoUrl={handleChangeLogoLogin}
              name={`${name}-login-image`}
              error={erros.login}
              isLogin
              cleanError={() => setErros((prev) => ({ ...prev, login: "" }))}
            />

            {/* {hasFreeTrial && (
              <CheckInput>
                <h3>Teste grátis ativo/inativo</h3>
                <input
                  type="checkbox"
                  checked={!!activeFreeTrial}
                  onChange={(evt) => setActiveFreeTrial(evt.target.checked)}
                />
              </CheckInput>
            )} */}
            {/* {!hasFreeTrial && (
              <Input
                label="Data de ínicio do teste grátis"
                value={formatDate(dataInicioFreeTrial)}
                setValue={(e) => setDiasFreeTrial(+e)}
                min={licenseUse || 0}
              />
            )} */}
            {/* <div>
              <InputSelector
                placeholder="Busque pelo nome do colaborador"
                customLabel="Colaboradores da Empresa"
                fluid
                search
                selection
                options={collabOptions}
              />
            </div> */}
            {/* <div>
              <InputSelector
                placeholder="Busque pelo nome do time"
                customLabel="Times da Empresa"
                fluid
                search
                selection
                options={teamsOptions}
              />
            </div> */}
          </div>
        </Forms>

        {/* <Reports>
          <h2>Emitir relatório</h2>
          <div>
            <InputSelector
              placeholder="Selecionar tipo"
              noLabel
              fluid
              search
              selection
              options={reportTypeUtils}
              handleChange={handleReportType}
            />

            <InputSelector
              placeholder="Selecionar relatório"
              noLabel
              fluid
              search
              selection
              options={trailsOptions}
            />
            <button
              className={!reportType ? "disable" : ""}
              title={
                !reportType
                  ? "Selecione o tipo de relatório"
                  : "Clique pra gerar o relatório selecionado "
              }
              onClick={() => handleReportChange(reportType)}
            >
              {loadingReport ? (
                <Loader className="custom__loader" active inline />
              ) : (
                "Gerar relatório"
              )}
            </button>
          </div>
          <h2>Gerar certificado</h2>
          <div>
            <InputSelector
              placeholder="Selecionar colaborador"
              noLabel
              fluid
              search
              selection
              options={collabOptions}
              handleChange={handleCollaboratorChange}
            />
            <InputSelector
              className="children"
              placeholder="Selecionar curso"
              noLabel
              fluid
              search
              selection
              options={collabCoursesOptions}
              handleChange={handleCourseChange}
            />
            <button
              className={
                !selectedCollaborator || !selectedCourse ? "disable" : ""
              }
              title={
                !selectedCollaborator && !selectedCourse
                  ? "Selecione o aluno e o curso"
                  : "Clique pra gerar o certificado selecionado"
              }
              onClick={() => generateCertificate()}
            >
              {loadingCertificate ? (
                <Loader active inline />
              ) : (
                "Gerar certificado"
              )}
            </button>
          </div>
          {certificateUrl && (
            <a href={certificateUrl} target="_blank">
              Clique para visualizar o certificado <MdOpenInNew />
            </a>
          )}
        </Reports> */}

        <ButtonContainer>
          <button onClick={submitUpdate}>
            {loading ? <div className="load" /> : "Atualizar painel"}
          </button>
        </ButtonContainer>

        {/* Modal pra confirmar exclusão  */}
        <Modal
          open={confirmModal}
          onClose={() => {
            setConfirmModal(false);
          }}
        >
          <ConfirmDelete
            closeModal={() => setConfirmModal(false)}
            deleteObject={() => handleRemoveManager(selectedManager)}
            copyModal={"gestor"}
          />
        </Modal>

        <Modal open={collabListModal} onClose={() => setCollabListModal(false)}>
          <CollaboratorsManagementModal
            closeModal={() => setCollabListModal(false)}
            invitationTotal={collaboratorsTotal}
            setCollaborators={setCollaborators}
            collaborators={collaborators}
            licenseUse={licenseUse}
            listCollaborators={true}
            setConfirmModal={setConfirmModal}
            confirmModal={confirmModal}
          />
        </Modal>

        <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
          <CollaboratorsManagementModal
            closeModal={() => setModalOpen(false)}
            invitationTotal={collaboratorsTotal}
            setCollaborators={setCollaborators}
            collaborators={collaborators}
            licenseUse={licenseUse}
            companyId={id}
            companyName={companyName}
          />
        </Modal>
      </Container>
    </div>
  );
};
